"use strict";var $export=require("./_export");$export($export.S,"Math",{log2:function(t){return Math.log(t)/Math.LN2}});